import React, { useState, useEffect } from 'react';
import '../style/Navbar.css';
import logo from '../assets/logo.webp';

const Navbar = ({ onNavigate }) => {
const [menuOpen, setMenuOpen] = useState(false);
const [dropdownOpen, setDropdownOpen] = useState(false);
const [isScrolled, setIsScrolled] = useState(false);
const [activePage, setActivePage] = useState('home');

// Smooth scroll effect for the glassmorphism header
useEffect(() => {
const handleScroll = () => setIsScrolled(window.scrollY > 30);
window.addEventListener('scroll', handleScroll);
return () => window.removeEventListener('scroll', handleScroll);
}, []);

const handleNavigation = (page) => {
setActivePage(page);
onNavigate(page);
setMenuOpen(false);
};

return (
  <header className={`nav-wrapper ${isScrolled ? 'scrolled' : ''}`}>
<nav className="nav-content" role="navigation" aria-label="Main Navigation">
      {/* Logo */}
    <div className="nav-logo" onClick={() => handleNavigation('home')}>
      <a href="https://carschalao.com/">
        <img src={logo} alt="CarsChalao - Premium Car Reviews and News" />
      </a>
    </div>

    {/* Desktop Links */}
    <ul className="nav-menu desktop">
      <li>
        <button
          onClick={() => handleNavigation('home')}
          className={`nav-link ${activePage === 'home' ? 'active' : ''}`}
        >
          Home
        </button>
      </li>

      <li
        className="nav-dropdown"
        onMouseEnter={() => setDropdownOpen(true)}
        onMouseLeave={() => setDropdownOpen(false)}
      >
        <span
          className={`nav-link dropdown-trigger ${
            ['hatchback', 'emi', 'insurance'].includes(activePage)
              ? 'active'
              : ''
          }`}
        >
          Explore Cars <span className="chevron-icon">▾</span>
        </span>

        <ul className={`dropdown-panel ${dropdownOpen ? 'visible' : ''}`}>
          <li>
            <button onClick={() => handleNavigation('hatchback')}>
              Latest Launches
            </button>
          </li>
          <li>
            <button onClick={() => handleNavigation('emi')}>
              EMI Calculator
            </button>
          </li>
          <li>
            <button onClick={() => handleNavigation('insurance')}>
              Car Insurance
            </button>
          </li>
        </ul>
      </li>

      <li>
        <button
          onClick={() => handleNavigation('news')}
          className={`nav-link ${activePage === 'news' ? 'active' : ''}`}
        >
          News
        </button>
      </li>

      <li>
        <button
          onClick={() => handleNavigation('reviews')}
          className={`nav-link ${activePage === 'reviews' ? 'active' : ''}`}
        >
          Reviews
        </button>
      </li>
    </ul>

    {/* CTA */}
    <div className="nav-cta desktop">
  <button
    className="premium-btn"
    onClick={() => handleNavigation('joincommunity')}
  >
    Join Community
  </button>
</div>

    {/* Hamburger */}
    <button
      className={`nav-toggle ${menuOpen ? 'active' : ''}`}
      onClick={() => setMenuOpen(!menuOpen)}
      aria-label="Open Menu"
    >
      <span className="line"></span>
      <span className="line"></span>
      <span className="line"></span>
    </button>

    {/* Mobile Menu */}
    <div className={`mobile-drawer ${menuOpen ? 'open' : ''}`}>
      <div className="mobile-links">
        <button
          onClick={() => handleNavigation('home')}
          className={activePage === 'home' ? 'active' : ''}
        >
          Home
        </button>

        <button
          onClick={() => handleNavigation('news')}
          className={activePage === 'news' ? 'active' : ''}
        >
          News
        </button>

        <button
          onClick={() => handleNavigation('reviews')}
          className={activePage === 'reviews' ? 'active' : ''}
        >
          Reviews
        </button>
<button
  onClick={() => handleNavigation('joincommunity')}
  className={activePage === 'joincommunity' ? 'active' : ''}
>
  Join Community
</button>

        <div className="mobile-divider" />

        <button
          onClick={() => handleNavigation('hatchback')}
          className={`sub-link ${
            activePage === 'hatchback' ? 'active' : ''
          }`}
        >
          Latest Launches
        </button>

        <button
          onClick={() => handleNavigation('emi')}
          className={`sub-link ${activePage === 'emi' ? 'active' : ''}`}
        >
          EMI Calculator
        </button>
      </div>
    </div>
  </nav>
</header>
)
}
export default Navbar;